module.exports = __webpack_public_path__ + "img/H5.72c4b357.png";